import { useEffect } from 'react';
import {
  initializeGA,
  initializePosthog,
} from '../../utils/initialize-third-party-integrations';

interface UseGAIntegrationWithConfigProps {
  enable?: boolean;
  measurementId?: string;
  onError?: (error: any) => void;
}

const useGAIntegrationWithConfig = ({
  enable = true,
  onError,
}: UseGAIntegrationWithConfigProps = {}) => {
  const segmentToken = process.env.REACT_APP_CFG_EVT_01;
  const posthogToken = process.env.REACT_APP_CFG_EVT_02;

  useEffect(() => {
    if (!enable) return;
    try {
      if (segmentToken) {
        initializeGA(segmentToken);
      }
      if (posthogToken) {
        initializePosthog(posthogToken);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing Google Analytics:', error);
      }
      onError?.(error);
    }
  }, [enable, segmentToken, posthogToken, onError]);

  return null;
};

export default useGAIntegrationWithConfig;
